export const tmaisRafflesColumns = [
  { label: 'Status', value: 'status', className: 'w-[120px]' },
  { label: 'Nome', value: 'display_name' },
  { label: 'Valido até', value: 'available_until' },
  { label: 'Dia do sorteio', value: 'available_from' },
  { label: 'Ações', value: 'actions', className: "w-11" },
]
